import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom'
import chain1 from "../assets/product/chain1.png";
import chain2 from "../assets/product/chain2.png";
import chain3 from "../assets/product/chain3.png";
import chain4 from "../assets/product/chain4.png";
import chain5 from "../assets/product/chain5.png";
import chain6 from "../assets/product/chain6.png";
import chain7 from "../assets/product/chain7.png";
import chain8 from "../assets/product/chain8.png";
import chain9 from "../assets/product/chain9.png";
import chain10 from "../assets/product/chain1.png";
import ProductServices from '../services/API/ProductServices';
import { BASE_URL } from '../services/Constant'
import CategoriesService from '../services/API/CategoriesService';

const Main = () => {
    const [products, setProducts] = useState([]);
    const [productsId, setProductsId] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [productsContent, setProductsContent] = useState([]);

  const fetchCategoryData = async () => {
    try {
      const res = await CategoriesService.getCategoryData();
      if (res.status) {
        const earringsCategory = res.data.find(category => category.name === "NEW ARRIVALS");
        if (earringsCategory) {
          setProductsId(earringsCategory);
          setProducts(earringsCategory.products);
          setProductsContent(earringsCategory);
        }
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching product data:", error);
    }
  };
  useEffect(() => {
    fetchCategoryData();
  }, []);
    return (
        <>
             <div className='container mx-auto px-4 py-10'>
      <div className='text-center'>
        <h2 className='text-3xl font-bold text-gray-800 mb-6'>NEW ARRIVALS</h2>
        <div className='mb-8'>
          <Link to={`/category/${productsId.id}`} >
            <button className='px-6 py-2 bg-black text-white rounded-lg shadow-lg hover:bg-gray-800 transition'>
              View All
            </button>
          </Link>
        </div>
      </div>
      
      <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 text-left'>
        {isLoading ? (
          <div className="flex justify-center items-center py-16 bg-[#fff]">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#F4CF38]"></div>
        </div>
        ) : (
          products.map((product) => (
            <Link key={product.id} to={`product/${product.id}`} className='block bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition transform hover:-translate-y-1'>
             <div className='relative h-48 w-full overflow-hidden rounded-lg'>
                                          <img
                                            src={`${BASE_URL}${product.image}`} alt={product.name}
                                            className='w-full h-full object-contain mx-auto'
                                          />
                                        </div>
              <h4 className='mt-4 text-base font-semibold text-gray-800'>{product.name.split(" ").slice(0, 4).join(" ")}{product.name.split(" ").length > 4 ? "..." : ""}</h4>
              <span className='text-gray-600 text-md font-bold'>${product.price}</span>
            </Link>
          ))
        )}
      </div>
    </div>
        </>
    )
}

export default Main